import { Select } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';
import { FIELD_CLASS } from './field.styles';

interface FormFieldSelectProps {
    field: FormFieldDto;
}

export function FormFieldSelect({ field }: FormFieldSelectProps) {
    return (
        <Select
            name={field.name}
            className={FIELD_CLASS}
            required={field.required}
            defaultValue={field.options?.defaultValue}
        >
            {field.choices?.map((choice) => (
                <option key={choice.value} value={choice.value}>
                    {choice.label}
                </option>
            ))}
        </Select>
    );
}
